<template>
  <div class="app-container flex-table-container">
    <el-form ref="searchModel" :model="searchModel" label-width="auto" class="table-query-form">
      <el-form-item prop="keyword" label="关键词">
        <el-input
          v-model="searchModel.keyword"
          placeholder="输入项目名称或委托单位"
          clearable
          @keyup.enter.native="getTableData(true)"
        ></el-input>
      </el-form-item>
      <el-form-item prop="dateRange" label="创建时间">
        <el-date-picker
          v-model="searchModel.dateRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          clearable
          @change="getTableData(true)"
        ></el-date-picker>
      </el-form-item>

      <el-form-item class="form-btn" label-width="0">
        <el-button type="success" @click="handleQuery">查询</el-button>
        <el-button @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>

    <keep-alive>
      <component ref="tableComponent" :is="TableComponent" :key="TableComponent" :tableType="tableType" :queryType="queryType">
        <div class="type-group">
          <div
            v-for="item in typeList"
            :key="item.value"
            :class="{ 'type-item': true, activated: tableType == item.value }"
            @click="tableType = item.value"
          >
            {{ item.label }}
          </div>
        </div>
      </component>
    </keep-alive>
  </div>
</template>

<script>
import TabelAllcation from './components/TabelAllcation';
import TableProcess from './components/TableProcess';

export default {
  components: { TabelAllcation, TableProcess },
  data() {
    return {
      searchModel: {
        reportCode: '',
        client: '',
        sampleName: '',
        itemName: null,
        orderType: 2,
        dateRange: []
      },
      orderTypeOptions: [
        {
          value: 2,
          label: '编号降序'
        },
        {
          value: 3,
          label: '编号升序'
        },
        {
          value: 0,
          label: '创建时间降序'
        },
        {
          value: 1,
          label: '创建时间升序'
        }
      ],
      tableType: 'table0',
      typeList: [
        {
          label: '未分配任务',
          value: 'table0'
        },
        {
          label: '已分配任务',
          value: 'table1'
        },
        {
          label: '报告进度',
          value: 'table2'
        }
      ],
      queryType: '0',
      TableComponent: 'TabelAllcation'
    };
  },
  computed: {},
  watch: {
    tableType(val) {
      switch (val) {
        case 'table0':
          this.TableComponent = 'TabelAllcation';
          this.queryType = '0';
          break;
        case 'table1':
          this.TableComponent = 'TabelAllcation';
          this.queryType = '1';
          break;
        case 'table2':
          this.TableComponent = 'TableProcess';
          break;
      }
    }
  },
  methods: {
    handleQuery() {
      this.$refs.tableComponent.setSearchModel(this.searchModel);
    },
    handleReset() {
      this.$refs.searchModel.resetFields();
      this.$refs.tableComponent.setSearchModel(this.searchModel);
    }
  }
};
</script>

<style lang="scss" scoped>
.type-group {
  display: inline-block;
  line-height: 1;
  vertical-align: middle;
  font-size: 0;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  overflow: hidden;

  .type-item {
    display: inline-block;
    padding: 9px 15px;
    font-size: 12px;
    border-right: 1px solid #dcdfe6;
    border-radius: 0;
    cursor: pointer;

    &:last-of-type {
      border-right: none;
    }
    &.activated {
      color: #ffffff;
      background-color: #009688;
      border-color: #009688;
    }
  }
}
</style>
